// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__27WnB","config":"styles_config__aZySI","appName":"styles_appName__1KHAa","label":"styles_label__HzJbI","field":"styles_field__1nbfc"};